import styled from "styled-components"
import { tablet, mobile } from "../../Responsive"

export const Container = styled.div`
    display: ${props => props.display};
    flex-direction: column;
    justify-content: center;
    border: 1.5px solid var(--secondary);
    border-radius: 10px;
    margin-top: 20px;
    padding: 20px;

    ${tablet({ padding: "10px" })}
`

export const Title = styled.h1`
    font-weight: 200;
`

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    ${tablet({ flexWrap: "wrap" })}
    ${mobile({ flexDirection: "column" })}
`

export const FormItem = styled.div`
    width: 50%;
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    ${mobile({ flexDirection: "column", width: "90%" })}
`

export const StyledLabel = styled.label`
    margin-right: 20px;

    ${tablet({ marginRight: "10px" })}
    ${mobile({ marginBottom: "10px" })}
`

export const StyledInput = styled.input`
    width: 70%;
    min-width: 200px;
    max-width: 400px;
    background-color: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    font-size: var(--fontS);
    border: none;
    border-bottom: 1px solid var(--primary);
    border-radius: 5px;
    height: 30px;

    :focus{
        border-bottom: 1px solid var(--secondary);
        outline: none;
    }

    ${mobile({ width: "90%" })}
`

export const Message = styled.div`
    color: var(--secondary);
`